"use strict";

import Test from "./../scenes/Test";
import ParticleEditor from "./../scenes/ParticleEditor";

/**
 * @class
 */
export default class Application {
    constructor() {

        //--bind the asset manager functions so we can call them with a short local variable--//
        P3.assets.texture = P3.assets.texture.bind(P3.assets);
        P3.assets.json = P3.assets.json.bind(P3.assets);

        //--load saves--//
        //Common.loadMute();
        //Common.loadGame();

        const j = P3.assets.json;
        Common.copy = j("copy");

        /**
         * @member {PIXI.Container}
         * @private
         */
        this._transitionLayer = new PIXI.Container();
        Common.stage.addChild(this._transitionLayer);

        //Common.audio.mute(true);
    }

    init() {
        this.showTestScene();
    }

    showTestScene() {
        const scene = new Test();
        scene.autoAppear = false;

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        scene.signals.next.add(function () {
            // this.showSplashScene();
        }, this);

        return scene;
    }


    showParticleEditor() {
        const scene = new ParticleEditor();
        scene.autoAppear = false;

        this.fadeTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        scene.signals.next.add(function () {
            // this.showSplashScene();
        }, this);

        return scene;
    }

    /**
     * @param {function} [a]
     * @param {function} [b]
     * @param {*} [scope]
     */
    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition();
        this._transitionLayer.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);
        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);
        transition.in();
    }

}
